import { Menu, MenuButton, MenuDivider, MenuItem } from "@szhsin/react-menu";
import React from "react";
import { api } from "../api";
import { showToast } from "../../../../utils/showToast";
import { getBaseUrlParams } from "../../../../utils/getBaseUrlParams";
import { useSelector } from "react-redux";

const requestMenuValues = {
  removeEmptyRevenueCategories: { endpoint: api.removeEmptyRevenueCategories },
  recalculateMemberships: { endpoint: api.recalculateMemberships },
  recalculateValues: { endpoint: api.recalculateValues },

  resetMappingServices: {
    endpoint: api.resetMapping,
    params: { scopes: "services", all_stores: false }
  },
  resetMappingProducts: {
    endpoint: api.resetMapping,
    params: { scopes: "products", all_stores: false }
  },
  resetStoresMapping: {
    endpoint: api.resetMapping,
    params: { scopes: "services,products", all_stores: false }
  },

  resetOrganizationMappingServices: {
    endpoint: api.resetMapping,
    params: { scopes: "services", all_stores: true }
  },
  resetOrganizationMappingProducts: {
    endpoint: api.resetMapping,
    params: { scopes: "products", all_stores: true }
  },
  resetOrganizationMapping: {
    endpoint: api.resetMapping,
    params: { scopes: "services,products", all_stores: true }
  },
  exportForAllSites: {
    endpoint: api.exportRevenueCategories,
    params: { all_stores: true }
  },
  exportForCurrent: {
    endpoint: api.exportRevenueCategories,
    params: { all_stores: false }
  }
};

const makeRequest = async ({ endpoint, params }) => {
  try {
    const { short_url } = getBaseUrlParams();
    let res = await endpoint({ short_url, ...params });
    showToast(res.data.message);
  } catch (err) {
    showToast(err.response.error);
    console.log(err);
  }
};

export function RevenueCategoriesMenu({ openPopup }) {
  const { canRecalculateValues, canExport, canImport } = useSelector(
    (state) => state.revenueCategories.actions
  );

  const onMenuClick = ({ value, syntheticEvent }) => {
    syntheticEvent.preventDefault();

    if (value == "upload") {
      openPopup(value);
    }

    if (requestMenuValues[value]) {
      makeRequest(requestMenuValues[value]);
      return;
    }
  };

  return canRecalculateValues | canExport | canImport ? (
    <Menu
      menuButton={
        <MenuButton>
          <span className="glyphicon glyphicon-cog" />
        </MenuButton>
      }
      overflow="auto"
      onItemClick={(eventObj) => onMenuClick(eventObj)}
      direction="right"
      align="start"
      transition
    >
      <>
        {canRecalculateValues && (
          <>
            <MenuItem value="removeEmptyRevenueCategories">
              <span>
                Remove Empty Revenue Categories for Business (Recalculation will be started)
              </span>
            </MenuItem>

            <MenuItem value="recalculateMemberships">
              <span>Recalculate Memberships Only For One Site</span>
            </MenuItem>

            <MenuItem value="recalculateValues">
              <span>Recalculate Values Only For One Site</span>
            </MenuItem>
            <MenuDivider />

            <MenuItem value="resetMappingProducts">
              <span>RESET STORE MAPPING (PRODUCTS ONLY)</span>
            </MenuItem>

            <MenuItem value="resetMappingServices">
              <span>RESET STORE MAPPING (SERVICES ONLY)</span>
            </MenuItem>

            <MenuItem value="resetStoresMapping">
              <span>RESET STORE MAPPING </span>
            </MenuItem>
            <MenuDivider />

            <MenuItem value="resetOrganizationMappingProducts">
              <span>RESET ORGANIZATION MAPPING (PRODUCTS ONLY)</span>
            </MenuItem>

            <MenuItem value="resetOrganizationMappingServices">
              <span>RESET ORGANIZATION MAPPING (SERVICES ONLY)</span>
            </MenuItem>

            <MenuItem value="resetOrganizationMapping">
              <span>RESET ORGANIZATION MAPPING </span>
            </MenuItem>
            <MenuDivider />
          </>
        )}

        {canImport && (
          <MenuItem value="upload">
            <span>Import SPs</span>
          </MenuItem>
        )}

        {canExport && (
          <>
            <MenuItem value="exportForAllSites">
              <span>Export SPs for All Sites</span>
            </MenuItem>
            <MenuItem value="exportForCurrent">
              <span>Export SPs for only current</span>
            </MenuItem>
          </>
        )}
      </>
    </Menu>
  ) : null;
}
